import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const options = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];
const TaxableCell = (props: GridCellProps) => {
  const { onChange, dataItem, dataIndex, field } = props;
  const { value } = dataItem;
  const _value = useMemo(() => options.find((item) => item.value === value), [value]);
  const isDisabled = !dataItem.selected;
  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.value.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  return (
    <GridCellBase {...props} className={'!bg-transparent'} title={_value?.label}>
      <div className="flex items-center gap-2">
        <span className="text-black">=</span>
        <DropDownList
          onChange={handleChange}
          value={_value}
          data={options}
          size="small"
          textField="label"
          disabled={isDisabled}
        />
      </div>
    </GridCellBase>
  );
};

export default TaxableCell;
